// extracted by mini-css-extract-plugin
export var acitonButtons = "_hf-0";
export var additionalIcon = "_hf-f";
export var block = "_hf-1";
export var blockContent = "_hf-7";
export var blockDescription = "_hf-8";
export var blockIcon = "_hf-9";
export var blockTitle = "_hf-6";
export var border = "_hf-a";
export var center = "_hf-l";
export var edge = "_hf-b";
export var edgeLabel = "_hf-c";
export var edgePath = "_hf-d";
export var error = "_hf-e";
export var flowchart = "_hf-g";
export var flowchartContent = "_hf-h";
export var highlighted = "_hf-3";
export var hover = "_hf-4";
export var icon = "_hf-i";
export var left = "_hf-m";
export var navButton = "_hf-j";
export var navButtons = "_hf-k";
export var right = "_hf-n";
export var selected = "_hf-2";
export var small = "_hf-5";